import { render, staticRenderFns } from "./deep-goal.vue?vue&type=template&id=496def24&scoped=true"
import script from "./deep-goal.vue?vue&type=script&lang=js"
export * from "./deep-goal.vue?vue&type=script&lang=js"
import style0 from "./deep-goal.vue?vue&type=style&index=0&id=496def24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496def24",
  null
  
)

export default component.exports